import React             from 'react';
import {observer,inject} from 'mobx-react';
import { RouterView }    from 'mobx-state-router';

import { Version    } from './commun/Version';
import { ToolTip    } from './commun/ToolTip';
import { Accueil    } from './Accueil';
import { ListeTome  } from './ListeTome';
import { Carte      } from './Carte';
import { Couverture } from './Couverture';
import { Genese     } from './Genese';
import { JDR        } from './JDR';
import { Livraison  } from './Livraison';
import { Contact    } from './Contact';

import version from '../donnees/version';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                               AppAros                         ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class AppAros extends React.Component{

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    /* -------------------------------- */
    /* Définition des routes à utiliser */
    /* -------------------------------- */

    const viewMap = {
      home       : <Accueil />,
      listetome  : <ListeTome />,
      carte      : <Carte />,
      couverture : <Couverture />,
      genese     : <Genese />,
      jdr        : <JDR />,
      livraison  : <Livraison />,
      contact    : <Contact />
    };

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (
      <div>

        {window.innerWidth >= 1080 && <Version version={version} />}

        <ToolTip />

        <div id="main">

            <RouterView routerStore={this.props.store.routerStore} viewMap={viewMap} />

        </div>

      </div>
    );
  }
}

inject("store") (observer(AppAros))

export default AppAros;


// WEBPACK FOOTER //
// ./src/components/AppAros.js